export const TUTORIAL_CHAIN = [
    {
        id: 'tutorial_1',
        title: 'Data Harvesting',
        description: 'Collect 15 data shards to prove your worth.',
        type: 'collect_shards',
        target: 15,
        reward: { xp: 100, factionRep: { scrappers: 10 } }
    },
    {
        id: 'tutorial_2',
        title: 'Pest Control',
        description: 'Eliminate 3 hunter programs.',
        type: 'kill_enemies',
        target: 3,
        reward: { xp: 200, factionRep: { maw_corps: 10 } }
    },
    {
        id: 'tutorial_3',
        title: 'Survive the Grid',
        description: 'Survive for 200 cycles.',
        type: 'survive_ticks',
        target: 200,
        reward: { xp: 300, factionRep: { neon_syndicate: 10 } }
    }
];
export function createTutorialQuest(index) {
    const t = TUTORIAL_CHAIN[Math.min(index, TUTORIAL_CHAIN.length - 1)];
    return {
        ...t,
        complete: false,
        progress: 0
    };
}
export function generateContract(seed, level) {
    const factions = ['maw_corps', 'neon_syndicate', 'scrappers'];
    const faction = factions[seed % factions.length];
    const types = ['collect_shards', 'kill_enemies', 'survive_ticks'];
    const type = types[(seed * 17) % types.length];
    let target = 0;
    let title = '';
    let xp = 0;
    switch (type) {
        case 'collect_shards':
            target = 20 + level * 5;
            title = `Collect ${target} data shards`;
            xp = target * 2;
            break;
        case 'kill_enemies':
            target = 5 + Math.floor(level / 2);
            title = `Destroy ${target} enemies`;
            xp = target * 10;
            break;
        case 'survive_ticks':
            target = 300 + level * 50;
            title = `Survive ${target} ticks`;
            xp = Math.floor(target / 5);
            break;
    }
    return {
        id: `contract_${seed}_${level}`,
        title,
        type,
        complete: false,
        progress: 0,
        target,
        faction,
        reward: {
            xp,
            factionRep: { [faction]: level * 5 }
        }
    };
}
export function handleQuestProgress(quests, type, amount) {
    let anyCompleted = false;
    for (const q of quests) {
        if (!q.complete && q.type === type) {
            q.progress += amount;
            if (q.progress >= q.target) {
                q.progress = q.target;
                q.complete = true;
                anyCompleted = true;
            }
        }
    }
    return anyCompleted;
}
